function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 172.43 80.624)",
  className: "st0"
}, "Set B");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st3",
  d: "M67.3,79.3H10.2l-0.1-38.9h4.4l52.9,35.5V79.3z M15.4,74.1h39.9L15.4,47.5V74.1z"
}), React.createElement("path", {
  className: "st3",
  d: "M82.2,75.8l52.9-35.4h4.4l-0.1,38.9H82.2C82.2,79.3,82.2,75.8,82.2,75.8z M134.1,47.5L94.2,74.1h39.9V47.5z"
}), React.createElement("rect", {
  x: 56.1,
  y: 16.7,
  className: "st3",
  width: 37.4,
  height: 32
}));

var SvgSetBIcon = function SvgSetBIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 386.9 93",
    style: {
      enableBackground: "new 0 0 386.9 93"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSetBIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/set-b-icon.115e5e83.svg";
export { ForwardRef as ReactComponent };